export default class Insurance {
  constructor({
    patientRelationshipToSubscriber,
    insuranceCardFrontImage,
    insuranceCardBackImage,
    insuranceName,
    payorId,
    planId,
    groupNumber,
    memberNumber,
    subscriberId,
    subscribersFirstName,
    subscribersLastName,
    subscribersDateOfBirth,
  }) {
    this.patientRelationshipToSubscriber = patientRelationshipToSubscriber;
    this.insuranceCardFrontImage = insuranceCardFrontImage;
    this.insuranceCardBackImage = insuranceCardBackImage;
    this.insuranceName = insuranceName;
    this.payorId = payorId;
    this.planId = planId;
    this.groupNumber = groupNumber;
    this.memberNumber = memberNumber;
    this.subscriberId = subscriberId;
    this.subscribersFirstName = subscribersFirstName;
    this.subscribersLastName = subscribersLastName;
    this.subscribersDateOfBirth = subscribersDateOfBirth;
  }

  toLuminisApiObject() {
    let payor;
    let plan;

    if (this.payorId) {
      payor = {
        id: this.payorId,
      };
    }

    if (this.planId) {
      plan = {
        id: this.planId,
      };
    }

    return {
      patientRelationshipToSubscriber: this.patientRelationshipToSubscriber,
      insuranceCardFrontImage: this.insuranceCardFrontImage,
      insuranceCardBackImage: this.insuranceCardBackImage,
      insuranceName: this.insuranceName,
      payor,
      plan,
      groupNumber: this.groupNumber,
      memberNumber: this.memberNumber,
      subscriberId: this.subscriberId,
      subscribersFirstName: this.subscribersFirstName,
      subscribersLastName: this.subscribersLastName,
      subscribersDateOfBirth: this.subscribersDateOfBirth,
    };
  }
}
